<template>
  <van-swipe-cell>
    <div class="info-item">
      <div class="info-img">
        <van-image width="4rem"
          height="4rem"
          src="https://img.yzcdn.cn/vant/cat.jpeg" />
        <div>
          <div class="veh-line">
            <div class="veh-dot"></div>
          </div>
        </div>
      </div>
      <div class="main-info">
        <div class="main-rel">
          <p class="info-name">{{ data.name }}</p>
          <p class="font-sec">Los / Region / Title</p>
        </div>
        <div class="sec-rel">
          <div class="rel-img">
            <van-image width="3rem"
              height="3rem"
              src="https://img.yzcdn.cn/vant/cat.jpeg" />
          </div>
          <div class="rel-info">
            <div class="info-name">Elizabeth Jordan</div>
            <div class="font-sec rel-sec">Contract A | 关联6条Pwc关系</div>
            <div class="rel-comp">红杉资本.合伙人</div>
          </div>
        </div>
        <div class="chk-icon"
          v-show="showChk">
          <van-checkbox v-model="checked"
            checked-color="#c52a1a"></van-checkbox>
        </div>
      </div>
    </div>
    <template #right>
      <van-button square
        text="取消收藏"
        class="delete-button" />
    </template>
  </van-swipe-cell>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      checked: false
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    showChk: {
      type: Boolean,
      required: true,
    },
  },
  components: {},
  mounted () { },
  methods: {},
};
</script>

<style lang='scss' scoped>
.delete-button {
  height: 100%;
  color: white;
  background-color: rgb(83, 84, 88);
}
.info-item {
  display: flex;
  .info-img {
    width: 4rem;
    padding: 10px;

    .veh-line {
      // width: 10px;
      // float: right;
      position: relative;
      height: 2.4rem;
      // transform: translateX(50%);
      margin-left: 50%;
      border-left: 1px solid #ccc;
      .veh-dot {
        position: absolute;
        bottom: 0;
        left: -0.3rem;
        width: 0.6rem;
        height: 0.6rem;
        // margin-left: 50%;
        // transform: translateX(50%);
        border-radius: 50%;
        background-color: #ccc;
      }
    }
  }
  .main-info {
    flex: 1;
    .info-name {
      font-weight: bolder;
    }
    .font-sec {
      font-size: 0.875rem;

      color: rgb(179, 179, 179);
    }
    .chk-icon {
      position: absolute;
      right: 6px;
      top: 10px;
    }
  }

  .sec-rel {
    display: flex;
    padding: 0.375rem;
    .rel-img {
      padding: 0.375rem;
      width: 3rem;
    }
    .rel-info {
      padding: 0.375rem;
      flex: 1;
      .rel-sec {
        padding: 0.5rem 0;
      }
      .rel-comp {
        // padding: 0.0625rem 0;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/favorites/FavoriteItem.vue